import httpClient from '@/lib/httpClient.js'
import { useQuery } from '@tanstack/react-query'

export default function useGetIncomeCategories() {
  const fetchData = async () => {
    const response = await httpClient.get('/team/transaction-category/income')
    return response.data.data
  }

  return useQuery({
    queryKey: ['transaction-categories', { type: 'income' }],
    queryFn: fetchData,
    // enabled: isAuthenticated,
  })
}
